<template>
  <v-app id="app">
    <DialogStatus ref="dlgError"></DialogStatus>
    <div class="allover" v-if="showIdle">
      <center>
        <Idle :idleMessage="idleMessage"></Idle>
      </center>
    </div>
    <router-view style="z-index: 0"/>
    <!--
    <div id="drag-and-drop-zone" class="uploader">
      <div class="browser">
        <label>
          <input type="file" name="files[]" title='Click to add Files'>
          <input id="file2" />
        </label>
      </div>
    </div>
    <div id="fileList" style="max-height: 200px;overflow-y:scroll">
    </div>
    -->

    <FileDialog ref="fileDialog" :categories="categories"></FileDialog>
    <!--<input id="file2" type="file" multiple="multiple"/>-->
    <vue-upload-component
      ref="upload"
      :maximum="100"
      :drop="true"
      input-id="file2"
      v-model="files"
      :multiple="true"
      :post-action="uploadURL"
      @input-file="inputFile"
      @input-filter="inputFilter"
    >
    </vue-upload-component>

    <v-dialog v-model="dialog" scrollable max-width="640px" min-height="320px" persistent>
      <v-card class="pa-4 upluadimg">
        <v-card-text class="text-xs-left title">
          Hinzufügen
        </v-card-text>
        <v-card-text style="overflow: auto; max-height: 400px">
          <v-layout v-for="(file, i) in files" :key="i" class="text-xs-left">
            <v-flex style="width: 100%">
              <v-progress-circular
                :value="file.progress"
                class="mx-2"
                color="#6274af"
              ></v-progress-circular>
              <v-icon color="green"
                      v-if="file.success && (file.response && (file.response && file.response.result && (file.response.result['ok'] !=='') && file.response.result.ok === true))">
                done
              </v-icon>
              <span v-if="file.error">{{file.error}}<v-icon color="red">error</v-icon></span>
              <span>{{file.name}}</span>
              <span
                v-if="file.response && file.response.result && (file.response.result['ok'] !=='') && file.response.result.ok === false"><v-icon
                color="red">error</v-icon></span>
              <span style="color:red;"
                    v-if="file.response && file.response.result && (file.response.result['ok'] !=='') && file.response.result.ok === false">{{file.response.result.message}}</span>
            </v-flex>
            <v-flex style="width: 100px"><span>{{toMB(file.size, 2)}}</span></v-flex>
            <v-flex style="width: 50px">
              <v-icon v-if="!uploadStarted" color="red" @click="removeUploadFile(i)">delete</v-icon>
            </v-flex>
            <v-flex style="width: 50px">
              <v-icon v-if="file.success" color="gray" @click="editFile(file.response)">edit</v-icon>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex style="height: 100px">&nbsp;</v-flex>
          </v-layout>
          <v-layout row wrap justify-center>
            <v-flex xs12>
              <v-select
                v-model="currentStatus"
                :items="statusList"
                label="Status"
                item-text="title"
                return-object
                solo
                @change="onChangeStatus"
                clearable
              >
              </v-select>
            </v-flex>
            <v-flex xs12>
              <v-select
                :items="categories"
                item-text="title"
                v-model="selectedCategories"
                return-object
                @change="onChangeCategory"
                class="my-input"
                chips
                solo
                :disabled="uploadStarted"
                multiple
                label="Diese Kategorieren zuweisen"
              >
                <template v-slot:selection="data">
                  <v-chip
                    :selected="data.selected"
                    close
                    @input="removeCategory(data.item)"
                  >
                    <strong>{{data.item.title}}</strong>
                  </v-chip>
                </template>
              </v-select>
            </v-flex>
          </v-layout>

        </v-card-text>

        <v-card-actions class="px-0">
              <v-btn v-if="!uploadStarted" @click="doCloseUpload" large outline color="#6f6f6e" class="text-none font-weight-bold">Abbrechen</v-btn>
            <v-spacer></v-spacer>
                <v-btn v-if="!uploadStarted" @click="doUpload" large outline color="#6f6f6e" class="text-none font-weight-bold">Jetzt upload starten</v-btn>
                <v-btn v-if="allDone" @click="doCloseUpload" large outline color="#6f6f6e" class="text-none font-weight-bold">Dialog schliessen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import $ from 'jquery'
import Vue from 'vue'
import mainFooter from './components/footer/MainFooter'
import DialogLoginFailed from './components/dialogs/DialogLoginFailed'
import sas from 'surfandscan'
import FileDialog from './components/pages/dialogs/FileDialog.vue'
import Idle from './components/widgets/Idle'
import VueUploadComponent from 'vue-upload-component'
import api from './components/login/Login.js'
import DialogStatus from './components/dialogs/DialogStatus'
export default {
  name: 'App',
  components: {DialogStatus, Idle, mainFooter, FileDialog, VueUploadComponent, DialogLoginFailed},
  data () {
    return {
      selectedCategories: [],
      currentStatus: null,
      files: [],
      statusList: [],
      idleMessage: null,
      showIdle: false,
      showApp: true,
      uploadStarted: false,
      dialog: false,
      allDone: false,
      categories: [],
      uploadURL: ''
    }
  },
  methods: {
    routeTo (url) {
      window.open(url, '_new')
    },
    removeUploadFile (index) {
      this.files.splice(index, 1)
      if (this.files.length === 0) {
        this.dialog = false
      }
    },
    toMB: function (bytes, decimals) {
      if (bytes === 0) return '0 Bytes'
      var k = 1024
      var dm = decimals <= 0 ? 0 : decimals || 2
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      var i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
    removeCategory: function (item) {
      console.log('removeCategory', item)
      var index = this.selectedCategories.indexOf(item)
      if (index > -1) {
        this.selectedCategories.splice(index, 1)
      }
    },
    OnManuellUpload () {
      console.log('OnManuellUpload', $('#file2'))
      $('#file2').trigger('click')
    },
    OnShowIdle (show) {
      console.log('OnShowIdle', show)
      this.idleMessage = false
      if (!this.showIdle) {
        this.idleStart = new Date().getTime()
      }
      this.showIdle = show
      if (show.message) {
        this.idleMessage = show.message
      }
    },
    OnErrorDlg (error) {
      let cmp = this
      console.log('OnErrorDlg', error, Vue.prototype.$api.getStackTrace())
      var desc = JSON.stringify(error)
      if (error && error.status === 400) {
        this.$refs.dlgError.open({
          newName: 'nn',
          messageTitle: 'Es ist Fehler aufgetreten (' + error.status + ' - ' + error.statusText + ')',
          type: 'Type',
          success: false,
          error: true,
          message: desc
        })
        return
      }
      if (error && error.status !== 200) {
        if (error.statusText === 'rejected') {
          if (Vue.prototype.$config.isCloud) {
            let fnc = function () {
              cmp.$router.push('/login')
            }
            api.doLogout(fnc, fnc)
          }
          return
        }
        if (error.statusText) {
          desc = error.statusText
        }
        this.$refs.dlgError.open({
          newName: 'nn',
          messageTitle: 'Es ist Fehler aufgetreten (' + error.status + ' - ' + error.statusText + ')',
          success: false,
          error: true,
          type: 'Type',
          message: desc
        })
      }
      if (error && error.success === false) {
        if (error.message) {
          desc = error.message
        }
        this.$refs.dlgError.open({
          newName: 'nn',
          title: 'Es ist Fehler aufgetreten',
          type: 'Type',
          description: desc
        })
      }
    },
    OnReloadConfig () {
      console.log('OnReloadConfig')
      sas.getConfig(this.onGetConfig)
      Vue.prototype.$storage.loadCategories(this.onLoadCategories)
    },
    restart () {
      this.$router.push('/')
    },
    pushTo (url) {
      this.$router.push(url)
    },
    onChangeCategory: function (categories) {
      console.log('categories', categories)
      var newCategories = []
      for (var i in categories) {
        var item = categories[i]
        newCategories.push(item.guid)
      }
      let cats = newCategories.join()
      this.uploadURL = sas.getStorageUploadUrl() + '&categories=' + cats
      if (this.currentStatus) {
        this.uploadURL += '&status=' + this.currentStatus.guid
      }
      for (var ii in this.files) {
        var item2 = this.files[ii]
        item2.postAction = this.uploadURL
      }
    },
    onChangeStatus: function (stati) {
      let categories = this.selectedCategories
      console.log('onChangeStatus', categories, stati)
      var newCategories = []
      for (var i in categories) {
        var item = categories[i]
        newCategories.push(item.guid)
      }
      let cats = newCategories.join()
      this.uploadURL = sas.getStorageUploadUrl() + '&categories=' + cats
      if (this.currentStatus) {
        this.uploadURL += '&status=' + this.currentStatus.guid
      }
      for (var ii in this.files) {
        var item2 = this.files[ii]
        item2.postAction = this.uploadURL
      }
    },
    onGetCategories (data) {
      this.categories = data.categories
    },
    initUploadDialog () {
      this.categories = Vue.prototype.$storage.getCategories()
      this.catNames = Vue.prototype.$storage.getCategoriesNamesList()
      this.catObjectsByGuid = Vue.prototype.$storage.getCategoriesObjectGuidList()
    },
    inputFile (newFile, oldFile) {
      if (!this.dialog) {
        this.initUploadDialog()
      }
      this.dialog = true
      console.log('inputFile', newFile, oldFile)
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        console.log('response', newFile.response)
        if (newFile.xhr) {
          //  Get the response status code
          console.log('status', newFile.xhr.status)
        }
      }
      if (newFile && oldFile) {
        // Update file

        // Start upload
        if (newFile.active !== oldFile.active) {
          console.log('Start upload', newFile.active, newFile)

          /*
          // min size
          if (newFile.size >= 0 && newFile.size < 100 * 1024) {
            newFile = this.$refs.upload.update(newFile, {error: 'size'})
          }

           */
        }

        // Upload progress
        if (newFile.progress !== oldFile.progress) {
          console.log('progress', newFile.progress, newFile)
        }

        // Upload error
        if (newFile.error !== oldFile.error) {
          console.log('error', newFile.error, newFile)
        }

        // Uploaded successfully
        if (newFile.success !== oldFile.success) {
          console.log('success', newFile.success, newFile)
        }
      }
      this.checkAllDone()
    },
    checkAllDone () {
      let done = true
      for (var i in this.files) {
        var item = this.files[i]
        if (!item.success && !item.error) {
          done = false
        }
      }
      this.allDone = done
    },
    /**
     * Pretreatment
     * @param  Object|undefined   newFile   Read and write
     * @param  Object|undefined   oldFile   Read only
     * @param  Function           prevent   Prevent changing
     * @return undefined
     */
    inputFilter (newFile, oldFile, prevent) {
      console.log('inputFilter')
      if (newFile && !oldFile) {
        // Filter non-image file
        if (!/\.(jpeg|jpe|jpg|png|pdf)$/i.test(newFile.name)) {
          this.$refs.dlgError.open({
            newName: '',
            cardTitle: 'Upload nicht möglich',
            type: 'Type',
            description: 'Diese Datei mit dem Namen "' + newFile.name + '" kann nicht hinzugefügt werden. Aktuell werden nur Bilder und PDF Dateien unterstützt.'
          })
          return prevent()
        }
      }

      // Create a blob field
      newFile.blob = ''
      let URL = window.URL || window.webkitURL
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file)
      }
    },
    onLoadCategories () {
      this.initDragAndDrop()
      this.uploadURL = sas.getStorageUploadUrl()
      Vue.prototype.$storage.loadStatus(this.onLoadStatus)
    },
    onLoadStatus (d) {
      console.log('onLoadStatus', d)
      this.showIdle = false
      this.showApp = true
      this.statusList = Vue.prototype.$storage.getStatusList()
      if (this.statusList && this.statusList.length > 0) {
        this.currentStatus = this.statusList[0]
      }
    },
    doCloseUpload () {
      this.uploadStarted = false
      this.$refs.upload.active = false
      this.files = []
      this.allDone = false
      let cmp = this
      this.$nextTick(function () {
        cmp.dialog = false
        cmp.$eventHub.$emit('OnShowIdle', false)
      })
    },
    doUpload () {
      this.uploadStarted = true
      this.$refs.upload.active = true
    },
    editFile (item) {
      this.currentItem = item
      this.currentItem.targetDate = new Date().getTime()
      console.log('edit file', item)
      this.$refs.fileDialog.open(this.currentItem)
    },
    onGetConfig (sasConfig) {
      Vue.prototype.$sasConfig = sasConfig
      // Vue.prototype.$sasConfig.licenseValid = false
    },
    initDragAndDrop () {
      console.log('init drag and drop', this.$refs.upload)
      /*
      var cmp = this
      window.jQuery('#app').dmUploader({
        url: function () {
          return cmp.getUploadURL()
        },
        fileName: 'files',
        dataType: 'json',
        headers: {
          'X-Auth-Token': Vue.credentials.authToken
        },
        allowedTypes: '*',
        extFilter: 'pdf', // jpg;jpeg;png;gif;
        onInit: function () {
          console.log('onInit uploader')
        },
        onBeforeUpload: function (id) {
          console.log('onBeforeUpload', id)
          cmp.$eventHub.$emit('OnShowIdle', true)
        },
        onNewFile: function (id, file) {
          $('#fadeMe').show()
          console.log('onNewFile', id, file)
        },
        onComplete: function () {
          console.log('upload complete')
          cmp.$eventHub.$emit('OnShowIdle', false)
          $('#fadeMe').hide()
        },
        onUploadProgress: function (id, percent) {
          var percentStr = percent + '%'
          // update_file_progress(id, percentStr);
          console.log('onUploadProgress', id, percentStr)
        },
        onUploadSuccess: function (id, data) {
          console.log(data)
          $('#fadeMe').hide()
          cmp.currentItem = data
          cmp.currentItem.targetDate = new Date().getTime()
          cmp.$refs.fileDialog.open(cmp.currentItem)
          cmp.$eventHub.$emit('OnShowIdle', false)
        },
        onUploadError: function (id, message) {
          $('#fadeMe').hide()
          cmp.$eventHub.$emit('OnShowIdle', false)
          swal('Upload Fehler', id + ' - ' + message, 'error')
        },
        onFileTypeError: function (file) {
          $('#fadeMe').hide()
          cmp.$eventHub.$emit('OnShowIdle', false)
          swal(
            Vue.i18n.translate('titleUploadWrongFileTyp'),
            Vue.i18n.translate('textUploadWrongFileTyp'),
            'error'
          )
        },
        onFileSizeError: function (file) {
          $('#fadeMe').hide()
          cmp.$eventHub.$emit('OnShowIdle', false)
          swal(
            Vue.i18n.translate('titleUploadWrongFileTyp'),
            Vue.i18n.translate('textUploadWrongFileTyp'),
            'error'
          )
        },
        onFileExtError: function (file) {
          $('#fadeMe').hide()
          cmp.$eventHub.$emit('OnShowIdle', false)
          swal(
            Vue.i18n.translate('titleUploadWrongFileTyp'),
            Vue.i18n.translate('textUploadWrongFileTyp'),
            'error'
          )
        },
        onFallbackMode: function (message) {
          cmp.$eventHub.$emit('OnShowIdle', false)
          swal(
            'Upload Fehler',
            'Browser not supported(do something else here!): ' + message,
            'error'
          )
        }
      })
      window.jQuery('#drag-and-drop-zone').hide()
      window.jQuery('#fileList').hide()
       */
    },
    OnLogin: function (done) {
      if (done) {
        console.log('OnLogin')
        // Vue.prototype.scanApi.updateUrl(Vue.prototype.$api)
        sas.token = Vue.prototype.$api.getAuthToken()
        sas.getConfig(this.onGetConfig)
        // Vue.prototype.$storage.loadCategories(this.onLoadCategories)
      }
    }
  },
  created () {
    Vue.prototype.$eventHub.$on('OnShowIdle', this.OnShowIdle)
    Vue.prototype.$eventHub.$on('OnManuellUpload', this.OnManuellUpload)
    Vue.prototype.$eventHub.$on('OnLogin', this.OnLogin)
    Vue.prototype.$eventHub.$on('OnReloadConfig', this.OnReloadConfig)
    Vue.prototype.$eventHub.$on('errorDlg', this.OnErrorDlg)
  },
  destroyed () {
    Vue.prototype.$eventHub.$off('OnShowIdle', this.OnShowIdle)
    Vue.prototype.$eventHub.$off('OnManuellUpload', this.OnManuellUpload)
    Vue.prototype.$eventHub.$off('OnLogin', this.OnLogin)
    Vue.prototype.$eventHub.$off('OnReloadConfig', this.OnReloadConfig)
    Vue.prototype.$eventHub.$off('errorDlg', this.OnErrorDlg)
  },
  mounted () {
    this.showApp = true
    this.OnLogin(true)
  }
}
</script>

<style>
  #app {
    font-family: 'Quicksand', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
</style>

<style lang="scss">
  @import 'main.scss'
</style>



// WEBPACK FOOTER //
// src/App.vue